<template>
  <div>
    <div class="cont-xw clearfix">
      <div class="jg-head">产品图片</div>
      <div style="overflow: hidden" class="text-center">
        <div class="text-center">
          <img
            class="form-group col-md-6 col-xs-6 col-sm-6"
            style="float:none"
            src="../../common/images/BH04KB.jpg"
          />
          <div @click="riseup" class="btn btn-success btn-circle top text-center">上升</div>
          <div>
            <a href="#fast" type="button" class="btn btn-danger btn-circle download text-center">下载</a>
          </div>
        </div>
      </div>
      <div class="jg-head">产品概述</div>
      <p>
        IVF-BH04KB是英诺尔腕带手表式高频读写器IVF-BH04的延伸，符合 ISO14443A/B、ISO15693等多协议、工作频段为13.56MHz，可通过蓝牙与电脑、手机、平板等具有蓝牙功能的设备通讯，无需APP软件，模拟蓝牙HID键盘的方式即连即用。
        1.外观图和尺寸
        蓝牙读写器外观如上页。适用Android蓝牙4.0以上版本手机、iOS iPhone 4S以上版本手机以及带有蓝牙的笔记本电脑。本产品通过蓝牙接口与手机等终端设备连接通讯，在手机上完成对非接触IC卡的读取功能。该设备体积小巧，操作简便，可灵活应用于个人、商户管理操作校园卡、公交卡、银行卡等应用场景。
        通讯接口为手机蓝牙；支持非接触14443A/B、CPU卡和M1卡、Desfire卡等IC卡读写；支持Android和iOS系统；内置可充电锂电池；无需二次开发。本产品通过蓝牙接口与手机等终端设备连接通讯，在手机上完成对非接触IC卡的读取功能。该设备体积小巧，操作简便，可灵活应用于个人、商户管理操作校园卡、公交卡、银行卡等应用场景。
        通讯接口为手机蓝牙；支持非接触14443A/B、CPU卡和M1卡、Desfire卡等IC卡读写；支持Android和iOS系统；内置可充电锂电池；无需二次开发。
      </p>
      <div class="jg-head">参数规格</div>
      <p>非接触卡读写</p>
      <p>支持非接触14443A/B、CPU卡和M1卡、Desfire卡、Felica等读写；</p>
      <p>对标准卡、异形卡都有良好的读写性能，读卡距离可达3-5cm。</p>
      <p>Q值为30±2%</p>
      <p>读卡速度可满足公交卡项目业务需要。1秒钟之内完成1k字节数据读或写。</p>
      <p>一次读写1k字节数据没有丢失和错误。</p>
      <p>工作频率：13.56MHz</p>
      <p>产品读卡面表面电磁场强度（Hmax）≤ 7.5A/m rms</p>
      <p>产品读卡面表面电磁场强度（Hmin）≥ 1.5A/m rms</p>
      <p>蓝牙通讯：</p>

      <p>蓝牙4.0以上BLE以上通讯标准。</p>
      <p>能同4.0以上BLE蓝牙Android手机设备通讯。能同蓝牙BLE4.0以上iOS设备通讯</p>
      <p>通讯速度能满足公交卡项目业务需要。</p>
      <p>空旷通讯距离5m</p>
      <p>BLE版本连接时间为1秒内（扫描+连接）。</p>

      <div class="jg-head">设备状态查询和显示</div>
      <p>①、待机时灯全面灭。没连上时绿灯闪烁，连上后绿灯常亮</p>
      <p>②、充电没有完成时，红灯常亮，充电完成时红灯灭掉。</p>
      <p>③、寻到卡片或者跟卡片交换数据时蓝灯闪烁，激活卡片时绿灯常亮。</p>
      <p>④、灯闪烁周期为1s。可通过SDK接口返回设备的软件版本号。</p>
      <div class="jg-head">电池充电以及功耗</div>
      <p>电池充电以及功耗</p>
      <p>电池容量：65mAh</p>
      <p>充电接口：MICRO-USB， 5V-500mA</p>
      <p>充电时间：70分钟</p>
      <p>待机时间：30天</p>
      <p>连续工作时间：10小时（读卡5000次以上）</p>
      <div class="jg-head">系统稳定性</div>
      <p>读卡和蓝牙通讯稳定。系统整体稳定，不死机，不出现异常。异常有看门狗重启机制。</p>
      <div class="jg-head">抗摔性、防水性</div>
      <p>1.2米高度跌落不损坏。受任意方向的水飞溅无有害的影响。</p>
      <div class="jg-head">电源开关特性</div>
      <p>5V充电。可使用充电宝或一般手机充电器充电。</p>
      <div class="jg-head">环境要求</div>
      <p>充电电压 5V±5%</p>
      <p>工作温度 -20℃~55℃</p>
      <p>贮运温度 -40℃~85℃</p>
      <p>相对湿度&lt; 90%</p>
      <p>贮运相对湿度 20%～93%</p>
      <p>大气压力 60kPa～110kPa</p>
      <img class="img-responsive center-block" src />
      <div class="jg-head">产品应用</div>
      <p>产品应用：腕带式手表、伸缩杆式读头、胸挂式阅读器、桌面式读写器。</p>
      <div id="fast" class="jg-head">下载</div>
      <ul>
        <li class="form-group">
          <FileDownload href="/static/IVF-BU/IVF-BH04KB规格书.doc">产品规格书</FileDownload>
        </li>
       
      </ul>
    </div>
  </div>
</template>

<script>
import FileDownload from "@/base/filedownload";
import { riseup } from "@/common/js/riseup.js";
export default {
  data() {
    return {};
  },
  methods: {
   
   riseup() {
      riseup()
      }

  },
  components: { FileDownload }
};
</script>

<style lang="stylus" scoped rel="stylesheet/stylus"></style>



// WEBPACK FOOTER //
// src/components/BH/04KB.vue